/* eslint-disable sonarjs/no-duplicate-string */
import dayjs from 'dayjs';
import { z } from 'zod';

export const newsSchema = z
  .object({
    id: z.number(),
    title: z.string(),
    description: z.string(),
    source: z.string().nullable(),
    created_at: z.string(),
    updated_at: z.string(),
    publish_date: z.string(),
    importance_score: z.number().optional(),
  })
  .transform((raw) => {
    return {
      id: raw.id,
      title: raw.title,
      description: raw.description,
      source: raw.source,
      createdAt: dayjs(raw.created_at).format('DD MMMM YYYY'),
      updatedAt: dayjs(raw.updated_at).format('DD MMMM YYYY'),
      publishDate: dayjs(raw.publish_date).format('DD MMMM YYYY'),
      importanceScore: raw.importance_score,
    };
  });

export type NewsEntityApi = z.input<typeof newsSchema>;
export type NewsEntity = z.infer<typeof newsSchema>;

export const newsResponseSchema = z.object({
  items: z.array(newsSchema),
  total: z.number(),
});

export type NewsResponseApi = z.input<typeof newsResponseSchema>;
export type NewsResponse = z.infer<typeof newsResponseSchema>;

export const newsPaginatorSchema = z.object({
  total_count: z.number(),
  page_size: z.number(),
  page: z.number(),
});

export type NewsPaginatorApi = z.input<typeof newsPaginatorSchema>;
export type NewsPaginator = z.infer<typeof newsPaginatorSchema>;

export const newsFullResponseSchema = z.object({
  items: z.array(newsSchema),
  total: z.number(),
  paginator: newsPaginatorSchema,
});

export type NewsFullResponseApi = z.input<typeof newsFullResponseSchema>;
export type NewsFullResponse = z.infer<typeof newsFullResponseSchema>;
